import { Subject } from 'rxjs';

const subject = new Subject();
const status = new Subject()

export const CommunicationService = {
    setLoggedInSatus: isAuthenticated => subject.next({ isAuthenticated: isAuthenticated }),
    // clearMessages: () => subject.next(),
    getLoggedInSatus: () => subject.asObservable()
};

export const userStatusCommunicationService = {
    setUserStatus: statusValue => status.next({statusValue : statusValue}),
    getUserStatus: () => status.asObservable()
}